import React from 'react';
import { useMutation, useQueryCache } from 'react-query';
import { ParticipantsAPI } from 'api/participant';
import { PARTICIPANTS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useRemoveParticipant() {
  const queryCache = useQueryCache();

  return useMutation(ParticipantsAPI.remove, {
    onSuccess: (
      { message },
      { id, onSuccess = () => {}, handleUndoDelete = () => {} }
    ) => {
      queryCache.invalidateQueries(PARTICIPANTS);

      const restoreMessage = (
        <>
          {message}{' '}
          <span className='undo-link' onClick={() => handleUndoDelete(id)}>
            Click here to undo.
          </span>
        </>
      );

      dispatchToast({
        message: restoreMessage,
        type: 'success',
        autohide: false,
      });
      onSuccess();
    },
  });
}
